import { Button } from "components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LinkButton } from "utils/enum/LinkButton";
import { AppLog } from "services";
import { RouteUrl, StatusMsg } from "utils";

export default function NewFeedLinkButton({ post }: { post: any }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onClickedLinkButton = () => {
    try {
      if (post?.link_button) {
        if (post.link_button === "Install Now") {
          let url = "";
          if (LinkButton.getTextByType(post.link_button) === "Android") {
            url = post.link_android_url;
          } else {
            url = post.link_ios_url;
          }
          window.open(url, "_blank");
        } else if (post.link_button === "Open Shop") {
          navigate(`${RouteUrl.viewShop}?id=${post.link_url}`);
        } else if (post.link_button === "Open Page") {
          navigate(`${RouteUrl.profile}?id=${post.link_url}`);
        } else {
          window.open(post.link_url, "_blank");
        }
      }
    } catch (error) {
      AppLog.show({
        message: `[onClickedLinkButton]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  return post?.link_button ? (
    <div className="flex flex-row justify-between bg-muted -mx-3 px-3 py-2 items-center">
      <div className="flex flex-col space-x-1 items-start">
        <p>{LinkButton.getTextByType(post?.link_button)}</p>
        <p className="text-xs text-muted-foreground">
          {post?.link_button === "Open Shop" ? post?.location_name : post?.link_button === "Open Page" ? post?.location_name : t(`${post?.link_sub_title}`)}
        </p>
      </div>
      <Button className={`${LinkButton.getColor(post?.link_button)} text-white hover:${LinkButton.getColor(post?.link_button)}`} onClick={onClickedLinkButton}>
        {t(`${post?.link_button}`)}
      </Button>
    </div>
  ) : (
    <></>
  );
}

